// Predicate-generating function. Often useful outside of Underscore.
export default function constant(value) {
  return function() {
    return value;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/constant.js
// module id = 275
// module chunks = 8